// noinspection JSUnusedLocalSymbols

import { DestroyRef, inject, Injectable } from '@angular/core';
import { UserDomainModel } from '../../../../../domainModels/user-domain-model';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '../../../../../services/toast-service';
import { ForgotPasswordRequest } from '../../../../../models/users/requests/forgot-password-request';
import { BaseViewModel } from '../../../../../models/base/base-view-model';
import { BehaviorSubject, Observable } from 'rxjs';
import { PortalType } from '../../../../../models/enum/shared/portal-type';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpStatusCode } from '@angular/common/http';
import { CustomError } from '../../../../../models/shared/custom-error';
import { Routes } from '../../../../../../routes/routes';

@Injectable()
export class ForgotPasswordViewModel extends BaseViewModel {
  private route = inject(ActivatedRoute);
  private userDomainModel = inject(UserDomainModel);
  private router = inject(Router);
  private toastService = inject(ToastService);
  private destroyRef = inject(DestroyRef);

  private _emailSent = new BehaviorSubject<boolean>(false);
  public readonly emailSent$ = this._emailSent as Observable<boolean>;

  private _preFillEmail = new BehaviorSubject<string>('');
  public readonly preFillEmail$ = this._preFillEmail as Observable<string>;

  private _preFillCode = new BehaviorSubject<string>('');
  public readonly preFillCode$ = this._preFillCode as Observable<string>;

  private _requestFailed = new BehaviorSubject<boolean>(false);
  public readonly requestFailed$ = this._requestFailed.asObservable();

  private listenToQueryParams = this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
    next: params => {
      const email = decodeURIComponent(decodeURIComponent(params?.Email || params?.email || ''));
      const password = decodeURIComponent(decodeURIComponent(params?.Password || params?.password || ''));
      const code = decodeURIComponent(decodeURIComponent(params?.Code || params?.code || ''));
      if (!!email) this._preFillEmail.next(email);
      if (!!code) this._preFillCode.next(code);
      if (!!email || !!code) {
        this.router?.navigate([], { queryParams: {}, replaceUrl: true, relativeTo: this.route }).then();
      }
    }
  });

  // Toast messages
  private sendingEmail = $localize`Sending E-mail...`;
  private readonly invalidEmailMessage = $localize`The email you entered is incorrect.`;

  public clearFailedState(): void {
    this._requestFailed.next(false);
  }

  public forgotPassword(req: ForgotPasswordRequest, portalType: PortalType): void {
    this._requestFailed.next(false);
    this._loadingOpts.addRequest(this.sendingEmail);
    this.userDomainModel.forgotPassword(req, portalType).subscribe({
      next: res => {
        this._loadingOpts.removeRequest(this.sendingEmail);
        this._emailSent.next(true);
      },
      error: (error: CustomError) => {
        if (error?.code === HttpStatusCode.Locked) {
          this.router.navigate([Routes.accessRestricted()], { replaceUrl: true }).then(() => {});
        } else if (portalType === PortalType.Member) {
          this._requestFailed.next(true);
          this.toastService.publishErrorMessage(this.invalidEmailMessage);
        } else {
          this._requestFailed.next(true);
          this.toastService.publishError(error);
        }
        this._loadingOpts.removeRequest(this.sendingEmail);
      }
    });
  }
}
